import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../auth/session'
import { deleteAccount, exportData, fetchMe, rename } from './api'

/** Query key of the signed-in user's profile. */
export const ME_KEY = ['me'] as const

/**
 * The signed-in user's profile: username, moderator role, ban.
 * @returns The query, idle while signed out.
 */
export function useMe() {
  const { session } = useAuth()
  return useQuery({ queryKey: ME_KEY, queryFn: fetchMe, enabled: session !== null, staleTime: 60_000 })
}

/**
 * Changes the username; the messages are reloaded to show it.
 * @returns The mutation.
 */
export function useRename() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: rename,
    onSuccess: (profile) => {
      queryClient.setQueryData(ME_KEY, profile)
      void queryClient.invalidateQueries({ queryKey: ['messages'] })
    },
  })
}

/**
 * Downloads the data export.
 * @returns The mutation.
 */
export function useExport() {
  return useMutation({ mutationFn: exportData })
}

/**
 * Deletes the account.
 * @returns The mutation.
 */
export function useDeleteAccount() {
  return useMutation({ mutationFn: deleteAccount })
}
